export default __webpack_public_path__ + "static/media/ExploreIcon.782f8312.svg";